'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../../utils/functional');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookieName = 'hasWitnessedInitialLoader'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'HeroLoader',

  data: function data() {
    return {
      allImagesLoaded: false,
      elementsToTransitionIn: {},
      headerLogo: null,
      imagesTransitioningFinished: false,
      images: [],
      isLoading: true,
      mobileImage: null,
      shouldTransition: _jsCookie2.default.get(cookieName) !== 'true'
    };
  },
  created: function created() {
    this.images = this.$root.images;
    this.mobileImage = this.$root.mobileImage;
    this.loadedImageIndex = 0;

    if (window.innerWidth < _utils.mediaBreakpoints.sm && this.mobileImage != null) {
      this.images[this.images.length - 1] = this.mobileImage;
    }

    this.headerLogo = (0, _functional.getElement)('.hd-Header_LogoLink svg');

    this.elementsToTransitionIn = {
      header: (0, _functional.getElement)('.hd-Header'),
      homepageHeroTitle: (0, _functional.getElement)('.sec-HomepageHero_Title'),
      homepageHeroText: (0, _functional.getElement)('.sec-HomepageHero_Text'),
      homepageHeroLinks: (0, _functional.getElement)('.sec-HomepageHero_Links'),
      homepageHeroScrollIndicator: (0, _functional.getElement)('.sec-HomepageHero_ScrollIndicator')
    };

    if (this.shouldTransition) {
      window.scrollTo(0, 0);
    } else {
      this.transitionInHiddenElements();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.shouldTransition) {
      document.body.classList.add('util-SiteOverflowed');

      window.scrollTo(0, 0);
    }

    this.images.forEach(function (image) {
      var imageObj = new Image();
      imageObj.onload = function () {
        _this.loadedImageIndex += 1;

        _this.allImagesLoaded = _this.loadedImageIndex === _this.images.length;
      };

      imageObj.src = image;
    });
  },


  watch: {
    allImagesLoaded: function allImagesLoaded(val) {
      if (val) this.onImagesLoaded();
    },
    imagesTransitioningFinished: function imagesTransitioningFinished(val) {
      if (val) this.onImagesTransitioningFinished();
    }
  },

  methods: {
    easeInQuad: function easeInQuad(t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },
    onImagesLoaded: function onImagesLoaded() {
      var _this2 = this;

      var time = 750;

      var minTime = time;
      var maxTime = 750 + this.images.length * 500;

      this.$el.classList.add('hero-Loader-isActive');

      if (this.shouldTransition) {
        this.images.reverse().forEach(function (_, index, arr) {
          time += 750;

          window.setTimeout(function () {
            var wantedIndex = _this2.images.length - (index + 1);

            _this2.$refs.image[wantedIndex].style.opacity = arr.length - 1 === index ? '1' : '0';

            _this2.imagesTransitioningFinished = arr.length - 1 === index;
          }, time);
        });
      } else {
        this.$refs.image[this.$refs.image.length - 1].style.opacity = '1';
      }
    },
    transitionInHiddenElements: function transitionInHiddenElements() {
      var _this3 = this;

      var elementsToTransitionIn = Object.values(this.elementsToTransitionIn).filter(function (el) {
        return el !== null;
      });

      var time = 100;

      var minTime = 0;
      var maxTime = elementsToTransitionIn.length * 250;

      window.setTimeout(function () {
        elementsToTransitionIn[0].style.opacity = '1';
      }, time);

      elementsToTransitionIn.slice(1).forEach(function (el, index, arr) {
        time = _this3.easeInQuad(index, minTime, maxTime, arr.length);

        window.setTimeout(function () {
          el.style.opacity = '1';

          if (index === arr.length - 1) {
            document.body.classList.remove('util-SiteOverflowed');
            _jsCookie2.default.set(cookieName, true, { expires: 1 });
          }
        }, time);
      });
    },
    onImagesTransitioningFinished: function onImagesTransitioningFinished() {
      var _this4 = this;

      var headerLogoWidth = this.headerLogo.getClientRects()[0].width;
      var loadingLogoWidth = this.$refs.logo.getClientRects()[0].width;

      var scaleAmount = headerLogoWidth / loadingLogoWidth;

      var loadingLogoFromTop = this.getLoadingLogoFromTopAfterScaleDown(scaleAmount);

      var _headerLogo$getBoundi = this.headerLogo.getBoundingClientRect(),
          headerLogoFromTop = _headerLogo$getBoundi.top;

      this.$refs.logo.parentNode.style.transform = 'translate(-50%, calc(-50% - ' + (loadingLogoFromTop - headerLogoFromTop) + 'px))';
      this.$refs.logo.style.transform = 'scale(' + scaleAmount + ')';

      this.$refs.logo.addEventListener('transitionend', function () {
        window.setTimeout(function () {
          _this4.$refs.logo.style.opacity = '0';
        }, 250);

        _this4.transitionInHiddenElements();
      });
    },
    getLoadingLogoFromTopAfterScaleDown: function getLoadingLogoFromTopAfterScaleDown(scaleAmount) {
      var newLoadingLogo = this.$refs.logo.cloneNode();
      newLoadingLogo.style.opacity = '0';
      newLoadingLogo.style.transform = 'scale(' + scaleAmount + ')';
      newLoadingLogo.style.transition = 'none';
      this.$refs.logo.parentNode.appendChild(newLoadingLogo);

      this.$refs.logo.style.display = 'none';

      var _newLoadingLogo$getBo = newLoadingLogo.getBoundingClientRect(),
          top = _newLoadingLogo$getBo.top;

      this.$refs.logo.style.display = '';

      newLoadingLogo.remove();

      return top;
    }
  }
};